import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconProcessor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconProcessor"><Path d="M12.0002 4.49693V2.49609M16 4.5V2.5M8.00018 4.5V2.49609M12 21.5V19.5M16 21.5V19.5M8 21.5V19.5M19.5 16H21.5M19.5 8H21.5M19.5 12H21.5M2.5 12H4.5M2.5 16H4.5M2.5 8H4.5M4.5 4.5H19.5V19.5H4.5V4.5ZM15.4988 11.999C15.4988 13.932 13.9318 15.499 11.9988 15.499C10.0658 15.499 8.49878 13.932 8.49878 11.999C8.49878 10.066 10.0658 8.49902 11.9988 8.49902C13.9318 8.49902 15.4988 10.066 15.4988 11.999Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconProcessor;
